import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TestImageLoad = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testImageLoad = async () => {
    setLoading(true);
    setResult('');
    
    try {
      const token = localStorage.getItem('adminToken');
      
      if (!token) {
        setResult('❌ No token found! Please login first.');
        setLoading(false);
        return;
      }

      setResult(`✓ Token found: ${token.substring(0, 20)}...\n`);

      // Test endpoint
      const imageUrl = `${BACKEND_URL}/api/admin/property-image/8f823260-f10e-4078-8b13-0b950f7ffb52/0_64c44d0d.jpg`;
      
      setResult(prev => prev + `✓ Trying to load: ${imageUrl}\n`);

      const response = await axios.get(imageUrl, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        responseType: 'blob',
        timeout: 10000
      });

      setResult(prev => prev + `✓ Response status: ${response.status}\n`);
      setResult(prev => prev + `✓ Blob size: ${response.data.size} bytes\n`);
      setResult(prev => prev + `✓ Blob type: ${response.data.type}\n`);

      // Try to create object URL
      const url = URL.createObjectURL(response.data);
      setResult(prev => prev + `✓ Object URL created: ${url.substring(0, 50)}...\n`);
      setResult(prev => prev + `\n🎉 SUCCESS! Image loaded correctly!\n`);

      // Show image
      const img = document.createElement('img');
      img.src = url;
      img.style.maxWidth = '200px';
      img.style.marginTop = '10px';
      img.style.border = '2px solid green';
      document.getElementById('test-image-container').appendChild(img);

    } catch (err) {
      setResult(prev => prev + `\n❌ ERROR: ${err.message}\n`);
      setResult(prev => prev + `❌ Status: ${err.response?.status}\n`);
      setResult(prev => prev + `❌ Data: ${JSON.stringify(err.response?.data)}\n`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="p-8 m-8 max-w-2xl">
      <h2 className="text-2xl font-bold mb-4">🧪 Test Image Loading</h2>
      <p className="text-sm text-slate-600 mb-4">
        This tests if the PropertyImage component can load images from the backend.
      </p>
      
      <Button 
        onClick={testImageLoad} 
        disabled={loading}
        className="mb-4"
      >
        {loading ? 'Testing...' : 'Run Test'}
      </Button>

      {result && (
        <pre className="bg-slate-100 p-4 rounded text-sm whitespace-pre-wrap font-mono">
          {result}
        </pre>
      )}

      <div id="test-image-container" className="mt-4"></div>
    </Card>
  );
};

export default TestImageLoad;
